import upd from 'immutability-helper';
import * as Env from 'widget/env';

const useHandleAddReaction = (setMessageList: Env.SetState<Env.Message[]>) => {
  const handleAddReaction = (msg: Env.Message) =>
    setMessageList(prevValue => {
      const msgIndex = prevValue.findIndex(item => item.id == msg.id);
      if (msgIndex < 0) return prevValue;

      return upd(prevValue, { [msgIndex]: { $set: msg } });
    });

  return handleAddReaction;
};

export default useHandleAddReaction;
